const childRoutes = (prop) => [
    {
        path: 'payment-report',
        name: prop + 'payment_report',
        meta: { auth: true },
        component: () => import('../pages/payment-report/List.vue')
    },
    {
        path: 'allowance-report',
        name: prop + 'allowance_report',
        meta: { auth: true },
        component: () => import('../pages/allowance-report/List.vue')
    },
    {
        path: 'training-course-summary-report',
        name: prop + 'training_course_summary_report',
        meta: { auth: true },
        component: () => import('../pages/training-course-summary-report/List.vue')
    },
    {
        path: 'training-course-wise-attendance-report',
        name: prop + 'training_course_wise_attendance_report',
        meta: { auth: true },
        component: () => import('../pages/training-course-wise-attendance-report/List.vue')
    },
    {
        path: 'performance-report',
        name: prop + 'performance_report',
        meta: { auth: true },
        component: () => import('../pages/performance-report/List.vue')
    },
    {
        path: 'training-summary-report',
        name: prop + 'training_summary_report',
        meta: { auth: true },
        component: () => import('../pages/training-summary-report/List.vue')
    },
    {
        path: 'training-material-report',
        name: prop + 'training_material_report',
        meta: { auth: true },
        component: () => import('../pages/training-material-report/List.vue')
    },
    {
        path: 'dormitory-others-charge-report',
        name: prop + 'dormitory_others_charge_report',
        meta: { auth: true },
        component: () => import('../pages/dormatory-others-charge-report/List.vue')
    },
    {
        path: 'trainee-performance-report',
        name: prop + 'trainee_performance_report',
        meta: { auth: true },
        component: () => import('../pages/trainee-performance-report/List.vue')
    },
    {
        path: 'trainer-performance-report',
        name: prop + 'trainer_performance_report',
        meta: { auth: true },
        component: () => import('../pages/trainer-performance-report/List.vue')
    },
    {
        path: 'training-course-evaluation-report',
        name: prop + 'training_course_evaluation_report',
        meta: { auth: true },
        component: () => import('../pages/training-course-evaluation-report/List.vue')
    },
    {
        path: 'circular-publication-report',
        name: prop + 'circular_publication_report',
        meta: { auth: true },
        component: () => import('../pages/circular-publication-report/List.vue')
    },
    {
        path: 'trainer-trainee-info-report',
        name: prop + 'trainer_trainee_info_report',
        meta: { auth: true },
        component: () => import('../pages/trainer-trainee-info-report/List.vue')
    }
]

const routes = [
    {
      path: '/training-e-learning-service/report',
      name: 'training_e_learning_service.report',
      component: () => import('@/layouts/TrainingServiceLayout.vue'),
      meta: { auth: true },
      children: childRoutes('training_e_service.barc.report')
    }
]

export default routes
